import { render, staticRenderFns } from "./PanelsTable.vue?vue&type=template&id=4b3396ad&scoped=true&"
import script from "./PanelsTable.vue?vue&type=script&lang=js&"
export * from "./PanelsTable.vue?vue&type=script&lang=js&"
import style0 from "./PanelsTable.vue?vue&type=style&index=0&id=4b3396ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3396ad",
  null
  
)

export default component.exports